<template>
  <section class="list">
    <component
      :is="component"
      key="infiniteCellList"
      :cell-list="cellList"
      :thumbnail-info="thumbnailInfo"
      :container-class-name="containerClassName"
      :content-info="contentInfo"
      :loading="loading"
      @cell-click-log="sendCellClickLog"
    />

    <div ref="scrollMonitor"></div>
  </section>
</template>

<script>
  import CellList from '@/components/section/template/cell/CellList'
  import InstantPlayCell from '@/components/section/template/cell/CellListInstantPlay'
  import {
    sendEventLogSearchListCell,
    sendEventLogSearchEditorPickCell,
  } from '@/common/util/log.v2.send'
  import scrollMonitor from 'scrollmonitor'

  export default {
    name: 'InfiniteScrollCellList',

    props: [
      'cellList',
      'thumbnailInfo',
      'containerClassName',
      'contentInfo',
      'loading',
    ],

    components: { CellList, InstantPlayCell },

    data() {
      return {
        component: null,
      }
    },

    methods: {
      loadMore() {
        this.$emit('load-more')
      },

      sendCellClickLog({ cellInfo = {}, index = -1, routeName = '' }) {
        this.$route.query.searchCategory === 'theme-list'
          ? sendEventLogSearchEditorPickCell({
              cellInfo: cellInfo,
              index: index,
              route: this.$route,
            })
          : sendEventLogSearchListCell({
              cellInfo: cellInfo,
              index: index,
              routeName: routeName,
            })
      },
    },

    created() {
      this.component =
        this.thumbnailInfo.cellType === 'band_82'
          ? 'instant-play-cell'
          : 'cell-list'
    },

    mounted() {
      // 장르 필터 변경 시, 시점 문제로 인한 업데이트 시점 안되서 인피니티 스크롤 불가한 이슈
      // 정확한 시점에 렌더링 될 수 있도록 찾아서 개선 필요
      setTimeout(() => {
        const monitorEl = this.$refs['scrollMonitor']
        this.watcher = scrollMonitor.create(monitorEl, 300)
        this.watcher.enterViewport(this.loadMore)
      }, 250)
    },
  }
</script>
